// src/App.tsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/sonner';

import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

import Login from './pages/Login';
import VerifyOTP from './pages/VerifyOTP';
import RequestAgency from './pages/RequestAgency';

import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Wallet from './pages/Wallet';
import Licenses from './pages/Licenses';
import Customers from './pages/Customers';
import Invoices from './pages/Invoices';
import NotificationsPage from './pages/Notifications';
import Support from '@/pages/Support';
import NotFound from './pages/NotFound';

import Onboarding from './pages/Onboarding';
import Contract from './pages/Contract';

const queryClient = new QueryClient();

const App = () => (
    <QueryClientProvider client={queryClient}>
        <TooltipProvider>
            <Toaster />
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/verify-otp" element={<VerifyOTP />} />
                        <Route path="/request-agency" element={<RequestAgency />} />

                        {/* Onboarding & Contract (Protected, بدون Layout) */}
                        <Route
                            path="/onboarding"
                            element={
                                <ProtectedRoute>
                                    <Onboarding />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/contract"
                            element={
                                <ProtectedRoute>
                                    <Contract />
                                </ProtectedRoute>
                            }
                        />

                        {/* Protected + Layout */}
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Dashboard />
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/products"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Products />
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/orders"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Orders />
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/wallet"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Wallet />
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/licenses"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Licenses />
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/customers"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Customers />
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/support"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Support />
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />

                        {/* ✅ صفحات جدید (فاکتور و نوتیفیکیشن) */}
                        // ✅ اضافه کردن هر دو مسیر
                        <Route path="/invoices" element={
                            <ProtectedRoute>
                                <Layout>
                                    <Invoices />
                                </Layout>
                            </ProtectedRoute>
                        } />
                        <Route path="/invoices/:id" element={
                            <ProtectedRoute>
                                <Layout>
                                    <Invoices />
                                </Layout>
                            </ProtectedRoute>
                        } />
                        <Route
                            path="/notifications"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <NotificationsPage />
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />

                        {/* Redirects */}
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </TooltipProvider>
    </QueryClientProvider>
);

export default App;
